export default __webpack_public_path__ + "static/media/support-banner.7f85ac93.svg";